/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PresentationRequestResult { 
    /**
     * Json Web Token with the PresentationRequest. Format: Header.Payload.Signature.
     */
    jwt?: string;
    /**
     * URI for Mobile App with the JWT PresentationRequest.
     */
    jwtInAppURI?: string;
    /**
     * QR Image in PNG format with the JWT PresentationRequest. Encoded in Base64 format
     */
    jwtInQR?: PresentationRequestResult.JwtInQREnum;
    /**
     * QR Image in PNG format with the GET request to JWT PresentationRequest. Encoded in Base64 format
     */
    getRequestToJwtInQR?: PresentationRequestResult.GetRequestToJwtInQREnum;
}
export namespace PresentationRequestResult {
    export type JwtInQREnum = '[B@36fc05ff';
    export const JwtInQREnum = {
        B36fc05ff: '[B@36fc05ff' as JwtInQREnum
    };
    export type GetRequestToJwtInQREnum = '[B@57c47a9e';
    export const GetRequestToJwtInQREnum = {
        B57c47a9e: '[B@57c47a9e' as GetRequestToJwtInQREnum
    };
}


